import React from 'react';
import { cn } from '../../shared/util/cn';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, variant = 'default', size = 'md', ...props }, ref) => {
    const baseStyles = 'inline-flex items-center justify-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-surface disabled:opacity-50 disabled:pointer-events-none';

    const variants = {
      default: 'hover:bg-[var(--color-mockup-border)]/50 focus-visible:ring-[var(--color-mockup-text-mid)]',
      primary: 'bg-primary text-white hover:opacity-95 focus-visible:ring-primary',
      secondary: 'bg-secondary text-white hover:opacity-95 focus-visible:ring-secondary',
      ghost: 'hover:bg-[var(--color-mockup-border)]/50 focus-visible:ring-[var(--color-mockup-text-mid)]',
      danger: 'text-[var(--color-mockup-coral)] hover:bg-[var(--color-mockup-coral-light)] focus-visible:ring-[var(--color-mockup-coral)]',
    };

    const sizes = {
      sm: 'h-8 w-8',
      md: 'h-10 w-10',
      lg: 'h-12 w-12',
    };

    return (
      <button
        className={cn(baseStyles, variants[variant], sizes[size], className)}
        ref={ref}
        {...props}
      />
    );
  }
);

IconButton.displayName = 'IconButton';
